import * as React from 'react';
import { Select } from '../../common';
import FieldHandler from '../../../models/interfaces/FieldHandler';
import { Environment } from '../../../models/enums/Environment';

interface EnvironmentInputProps extends FieldHandler<Environment> { 
	onChange: (env: Environment) => any;
}

interface EnvironmentInputState {}

export class EnvironmentInput extends React.Component<EnvironmentInputProps, EnvironmentInputState> {
	render() {
		return (
			<Select
				label="Environment"
				fullWidth
				options={
					[
						{ text: 'DEVELOPMENT', value: Environment.Development.value },
						{ text: 'PRODUCTION', value: Environment.Production.value }
					]
				}
				{...this.props}
				value={this.props.value?.value.toString()}
				onChange={(event) => {
					const env = new Environment().fromValue(Number(event.target.value));
					this.props.onChange(env);
				}}
			/>
		);
	}
}